import { LmsClassGroupType } from '../../../constants/types/lms-type';

/**
 * 같은 클래스 안에 이름이 겹치는 반이 있는지 확인한다.
 * 이름을 고칠 때는 자기 자신과 비교하면 항상 중복이므로 `excludeId` 로 제외한다.
 */
export const isDuplicatedClassGroupName = (
  name: string,
  classGroups: LmsClassGroupType[] = [],
  excludeId?: number,
) =>
  classGroups.some(
    (classGroup) =>
      classGroup.id !== excludeId && classGroup.name === name.trim(),
  );

export const DUPLICATED_CLASS_GROUP_NAME_MESSAGE =
  '같은 이름의 반이 이미 존재합니다.';
